import { Component, inject } from '@angular/core';
import { TileCreatorService } from '../../services/tile-creator.service';
import { TILE_REQUEST } from '../../tokens/tile-request.token';

@Component({
  standalone: true,
  selector: 'demo-count-custom-component-setup-wizard',
  template: '',
})
export class DemoCountCustomComponentSetupWizardComponent {
  constructor(tileCreatorService: TileCreatorService) {
    const tileDefinition = inject(TILE_REQUEST).tileInstance;
    tileDefinition.tileType = 'demo-count-custom-component';
    tileCreatorService.onChange.next();
  }
}
